import Head from 'next/head';

const title = 'Commercial Cleaning in CT & NY | B&B Commercial Cleaning';
const description =
  'Office, multifamily, window, floor, and select residential cleaning in Connecticut and New York, backed by over 20 years of reliable service.';
const canonicalUrl = 'https://bbcommercialcleaning.com';
const imageUrl = `${canonicalUrl}/images/brand/bb-logo.png`;

const localBusinessJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${canonicalUrl}/#business`,
  name: 'B&B Commercial Cleaning Services LLC',
  url: canonicalUrl,
  image: imageUrl,
  logo: imageUrl,
  description,
  telephone: ['+1-203-241-4186', '+1-845-558-4176'],
  areaServed: [
    { '@type': 'State', name: 'Connecticut' },
    { '@type': 'State', name: 'New York' },
  ],
  foundingDate: '2000',
  sameAs: ['https://www.facebook.com/bbcommercialcleaning/'],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Cleaning services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Office cleaning' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Multifamily common-area cleaning' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Window cleaning' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Floor cleaning' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Select residential cleaning' } },
    ],
  },
};

export function Meta({ children }: { children?: React.ReactNode }) {
  return (
    <>
      <Head>
        <meta content="width=device-width, initial-scale=1" name="viewport" />
        <title>{title}</title>
        <meta content={description} name="description" />
        <link href="/favicon.png" rel="icon" type="image/png" />
        <link href="/favicon.png" rel="apple-touch-icon" />
        <link href="/favicon.ico" rel="shortcut icon" />
        <link href={canonicalUrl} rel="canonical" />
        <meta content={title} property="og:title" />
        <meta content={description} property="og:description" />
        <meta content="B&B Commercial Cleaning" property="og:site_name" />
        <meta content="website" property="og:type" />
        <meta content={canonicalUrl} property="og:url" />
        <meta content={imageUrl} property="og:image" />
        <meta content="summary_large_image" name="twitter:card" />
        <script
          dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessJsonLd) }}
          type="application/ld+json"
        />
      </Head>
      {children}
    </>
  );
}
